import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { PointsOnboardingDialogContentContainer } from '@/features/points/dialogs/points-onboarding-dialog/PointsOnboardingDialogContentContainer'
import { Dialog } from '@/ui/atoms/dialog/Dialog'

function PointsOnboardingDialog({ open, setOpen }: CommonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <PointsOnboardingDialogContentContainer closeDialog={() => setOpen(false)} />
    </Dialog>
  )
}

export const pointsOnboardingDialogConfig: DialogConfig<CommonDialogProps> = {
  options: {
    closeOnAccountChange: false,
  },
  element: PointsOnboardingDialog,
  name: 'PointsOnboardingDialog',
}
